<div style="padding: 2rem;">
  @if(pageReady){
  <div>
    @if(storageConversations.length > 0){
      <div class="card-container">
        <p style="font-size: 18px;">Click on a conversation to start the chat:</p>
        <a *ngFor="let item of storageConversations" class="card-item" href="/chat?conversationId={{item.conversationId}}">
          Chat with: <b>{{item.details?.advisorName}}</b><br>
          @if(item.lastUpdate){
            <span class="last-message-date">Last message: {{item.lastUpdate | date:'medium'}}</span>
            <span class="last-message-text">{{item.lastMessage}}</span>
            @if(item.media){
            <span class="last-message-media"><i>-- Has media attachment --</i></span>
            }
          } @else {
            <span class="last-message-text"><i>-- No Message --</i></span>
          }
        </a>
      </div>
    } @else {
      <p style="font-size: 18px; font-weight: bold; color: #c26d00;">No Conversation exist.</p>
    }
  </div>
  <button class="btn otp-verify-btn" (click)="openOtpVerifyWindow($event)">Please click here to start a new chat if you have an OTP code.</button>
  } @else {
    <div class="page-loader"><div class="spinner"></div></div>
  }
</div>